import {
  GET_COMPANY_COMPLIANCE,
  GET_COMPANY_COMPLIANCE_DETAIL,
  GET_COMPANY_COMPLIANCE_FILTER_COMPANY,
  GET_COMPILANCE,
  GET_COMPILANCE_CATEGORY,
  GET_COMPILANCE_ITEM,
  GET_COMPILANCE_SUB_CATEGORY,
  GET_COMPILANCE_SUB_CATEGORY_CATEGORY_FILTER,
  GET_COMPLIANCE_DETAIL,
  GET_COMPLIANCE_FILTER_CATEGORY,
  GET_COMPLIANCE_FILTER_COMPANY,
  GET_COMPLIANCE_FILTER_SUB_CATEGORY,
  GET_COMPLIANCE_ITEM__FILTER_CATEGORY,
  GET_COMPLIANCE_ITEM__FILTER_COMPANY,
  GET_COMPLIANCE_ITEM_DETAIL,
  GET_COMPLIANCE_ITEM_FILTER_COMPLIANCE_NAME,
  GET_QC_STAGE
} from "./types";

const initialStateChart = {
  labels: [],
  datasets: []
};
const initialState = {
  //QC STAGE
  getQcStages: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getComplianceCategory: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getComplianceSubCategory: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getComplianceSubCategoryCategoryFilter: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getComplianceItem: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getComplianceItemFilterComplianceName: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getComplianceItemFilterCategory: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getComplianceItemFilterCompany: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  //
  getCompliance: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getComplianceFilterCompany: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getComplianceFilterCategory: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getComplianceFilterSubCategory: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getComplianceDetail: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getCompanyCompliance: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getCompanyComplianceFilterCompany: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getCompanyComplianceDetail: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getComplianceItemDetail: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  }
};
const C_reducer = (state = initialState, { type, payload }) => {
  switch (type) {
    //QC STAGE
    case GET_QC_STAGE:
      return Object.assign({}, state, {
        getQcStages: payload
      });
    // Accounts Compliance Category
    case GET_COMPILANCE_CATEGORY:
      return Object.assign({}, state, {
        getComplianceCategory: payload
      });
    // Accounts Compliance SubCategory
    case GET_COMPILANCE_SUB_CATEGORY:
      return Object.assign({}, state, {
        getComplianceSubCategory: payload
      });
    case GET_COMPILANCE_SUB_CATEGORY_CATEGORY_FILTER:
      return Object.assign({}, state, {
        getComplianceSubCategoryCategoryFilter: payload
      });
    // Accounts Compliance Item
    case GET_COMPILANCE_ITEM:
      return Object.assign({}, state, {
        getComplianceItem: payload
      });
    case GET_COMPLIANCE_ITEM_FILTER_COMPLIANCE_NAME:
      return Object.assign({}, state, {
        getComplianceItemFilterComplianceName: payload
      });
    case GET_COMPLIANCE_ITEM__FILTER_CATEGORY:
      return Object.assign({}, state, {
        getComplianceItemFilterCategory: payload
      });
    case GET_COMPLIANCE_ITEM__FILTER_COMPANY:
      return Object.assign({}, state, {
        getComplianceItemFilterCompany: payload
      });
    //
    case GET_COMPILANCE:
      return Object.assign({}, state, {
        getCompliance: payload
      });
    case GET_COMPLIANCE_FILTER_COMPANY:
      return Object.assign({}, state, {
        getComplianceFilterCompany: payload
      });
    case GET_COMPLIANCE_FILTER_CATEGORY:
      return Object.assign({}, state, {
        getComplianceFilterCategory: payload
      });
    case GET_COMPLIANCE_FILTER_SUB_CATEGORY:
      return Object.assign({}, state, {
        getComplianceFilterSubCategory: payload
      });
    case GET_COMPLIANCE_DETAIL:
      return Object.assign({}, state, {
        getComplianceDetail: payload
      });
    //
    case GET_COMPANY_COMPLIANCE:
      return Object.assign({}, state, {
        getCompanyCompliance: payload
      });

    case GET_COMPANY_COMPLIANCE_FILTER_COMPANY:
      return Object.assign({}, state, {
        getCompanyComplianceFilterCompany: payload
      });
    case GET_COMPANY_COMPLIANCE_DETAIL:
      return Object.assign({}, state, {
        getCompanyComplianceDetail: payload
      });
    case GET_COMPLIANCE_ITEM_DETAIL:
      return Object.assign({}, state, {
        getComplianceItemDetail: payload
      });

    default:
      return state;
  }
};
export default C_reducer;
